















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "financialStatementTips",
  components: {
  },
})
export default class extends Vue {
}
